/**
 * Top-level profile edit form: renders role-specific field groups and save actions.
 * Form state lives in ProfileFormProvider (see ProfileFormContext).
 */

import {
    OTHER_PROFILE_FORM_GROUPS,
    PARENT_PROFILE_FORM_GROUPS,
    ProfileFormGroupDefinition,
    STUDENT_PROFILE_FORM_GROUPS,
} from "../config/profileFormGroups";
import { useProfileForm } from "../context/useProfileForm";
import { RoleProfileForm } from "./RoleProfileForm";

const ProfileFormType: Record<string, ProfileFormGroupDefinition[]> = {
    parent: PARENT_PROFILE_FORM_GROUPS,
    student: STUDENT_PROFILE_FORM_GROUPS,
    other: OTHER_PROFILE_FORM_GROUPS,
} as const;

export function ProfileForm() {
    const { person, readOnly, values, updateStandardField, updateCustomField } =
        useProfileForm();

    const fieldHandlers = {
        values,
        readOnly,
        onUpdateStandardField: updateStandardField,
        onUpdateCustomField: updateCustomField,
    };

    const groups = ProfileFormType[person.role];

    return (
        <RoleProfileForm person={person} groups={groups} {...fieldHandlers} />
    );
}
